import { render } from "./PageLayout.vue?vue&type=template&id=0ecc7639"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=0ecc7639&lang=scss"

import exportComponent from "/Users/perthpiti/InsightEra/ENOLA/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__